module.exports = __webpack_public_path__ + "static/media/v_hero.4c843489.mp4";